import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Form, Button } from 'react-bootstrap';
import { Multiselect } from 'multiselect-react-dropdown';
import CyberSecurity from '../../../apis/cyberSecurityData';
import _ from 'lodash';
//comps
import CustomPopover from '../../common/CustomPopover/CustomPopover';
import AddActorPopup from './AddActorPopup';

const ActorSelect = ({ onActorValuesChange }) => {
  //redux store state
  const accessToken = useSelector(state => state.accessToken);
  //comp state
  const [options, setOptions] = useState([]);
  const [selectedActor, setSelectedActor] = useState('');
  const [newTech, setNewTech] = useState('');

  const getOptions = async () => {
    const response = await CyberSecurity.get('/actoroptions', {
      headers: {
        Authorization: 'Bearer ' + accessToken
      }
    })
    setOptions(response.data);
  }

  //redux store state
  const darkMode = useSelector(state => state.darkMode)
  //comp local state
  const [selectedValues, setSelectedValues] = useState([])

  useEffect(() => {
    getOptions();
  }, [])

  const onSelect = (values, selectedItem) => {
    setSelectedActor([selectedItem])
    onActorValuesChange(selectedItem)
  }

  const onRemove = (values, selectedItem) => {
    setSelectedActor([selectedItem])
    onActorValuesChange(selectedItem)
  }

  return (
    <div className="d-flex align-items-center multi-select">
      <Multiselect
        options={options} // Options to display in the dropdown
        isObject={false} //add if using plain array
        selectedValues={selectedActor} // Preselected value to persist in dropdown
        onSelect={onSelect} // Function will trigger on select event
        onRemove={onRemove} // Function will trigger on remove event
        closeOnSelect
        placeholder="Choose Actor"
        closeIcon="cancel"
        style={{
          multiselectContainer: { // To change css for multiselect (Width,height,etc..)
            background: darkMode ? '#25272D' : 'transparent',
            borderRadius: '5px',
            marginLeft: '8px',
            width: '400px'
          },

          optionContainer: { // To change css for option container
            display: 'flex',
            flexDirection: 'column',
            background: darkMode ? '#25272D' : 'transparent',
          },
          chips: { // To change css chips(Selected options)
            background: 'grey',
            fontSize: '12px',
          }
        }}
      />

      <CustomPopover
        trigger={<span className="material-icons ml-3 text-light pointer" style={{ fontSize: '24px' }}>add_circle_outline</span>}
        content={<AddActorPopup getActorOptions={getOptions} />}
        placement="bottom"
        title="Add new Actor"
        rootClose={true}
      />
    </div>
  )
}

export default ActorSelect
